import React, {useEffect, useRef, useState} from "react"
import ReactMarkdown from "react-markdown"
import {connect} from "react-redux"
import Styles from "./index.less"
import mdList from "../../static/md/md.json"
import mdStyles from "./md.css"

interface MDViewerProps {
    markdownName: string
}

interface MdList {
    openapiList: any
}

const MDViewer = (props: MDViewerProps) => {
    const mdRef = useRef<HTMLDivElement>(null)
    const markDownList: any = mdList
    useEffect(() => {
        const openapi =
            markDownList.openapiList.commonBegin +
            markDownList.openapiList[props.markdownName] +
            markDownList.openapiList.commonEnd
        const service =
            markDownList.serviceList.commonBegin +
            markDownList.serviceList[props.markdownName] +
            markDownList.serviceList.commonEnd
        mdRef.current!.innerHTML = openapi + service
    }, [props.markdownName])
    return <div ref={mdRef} className={mdStyles["markdown-body"]} />
}

export default connect((state: any) => {
    return {
        markdownName: state.markdownName,
    }
})(MDViewer)
